module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "max-width": "500px"
    },
    attrs: {
      "id": "login-overlay"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(!_vm.checkUser) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-block",
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("\n              Login\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-block",
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v("\n              Home\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.checkUser) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "well",
    staticStyle: {
      "margin-bottom": "5px",
      "min-height": "200px"
    }
  }, [(_vm.pending == true) ? _c('div', [_c('p', [_vm._v("\n                  Name: "), _c('strong', [_vm._v(_vm._s(_vm.compUserName))])]), _vm._v(" "), (_vm.compBookingId) ? _c('p', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.related),
      expression: "related"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.related) ? _vm._i(_vm.related, null) > -1 : (_vm.related)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.related,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.related = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.related = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.related = $$c
        }
      }
    }
  })]), _vm._v("\n                  Issue is related to\n                  "), _c('strong', [_vm._v("Booking No: " + _vm._s(_vm.compBookingId))])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Describe your problem below:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ticket.Description),
      expression: "ticket.Description"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:8'),
      expression: "'required|min:8'"
    }],
    staticClass: "form-control",
    class: {
      input: true,
        'has-error': _vm.errors.has('description'),
    },
    attrs: {
      "name": "description",
      "rows": "3",
      "placeholder": "please describe your problem here",
      "data-vv-delay": "1000",
      "id": "supportTextArea"
    },
    domProps: {
      "value": (_vm.ticket.Description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ticket, "Description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('description')),
      expression: "errors.has('description')"
    }],
    staticClass: "text-danger h5"
  }, [_vm._v(_vm._s(_vm.errors.first("description")))])])]) : _vm._e(), _vm._v(" "), (_vm.sent == true) ? _c('div', [(_vm.errorMsg) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm._v(" "), (_vm.alertMsg) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_c('p', [_vm._v(_vm._s(_vm.alertMsg))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.sent) ? _c('button', {
    staticClass: "btn btn-success btn-block",
    attrs: {
      "disabled": _vm.errors.has('description') || !_vm.ticket.Description
    },
    on: {
      "click": function($event) {
        _vm.createTicket()
      }
    }
  }, [_vm._v("\n                Create Ticket\n              ")]) : _vm._e(), _vm._v(" "), (_vm.sent) ? _c('button', {
    staticClass: "btn btn-success btn-block",
    attrs: {
      "disabled": _vm.sent
    },
    on: {
      "click": function($event) {
        _vm.createTicket()
      }
    }
  }, [_vm._v("\n                Ticket Sent Successfully\n              ")]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-block",
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_vm._v("\n              Go Home\n            ")])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header text-center",
    staticStyle: {
      "padding-top": "0px !important",
      "padding-bottom": "0px !important"
    }
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-support"
  }), _vm._v(" Contact Support")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "well",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('div', [_c('h3', [_vm._v("\n                  You have to be logged in to create a customer support ticket\n                ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b1e7c5e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SharedComponents/ContactSupport.vue
// module id = 603
// module chunks = 2